import { render, staticRenderFns } from "./WebTwoTrainReport.vue?vue&type=template&id=33e7a115&scoped=true&"
import script from "./WebTwoTrainReport.vue?vue&type=script&lang=js&"
export * from "./WebTwoTrainReport.vue?vue&type=script&lang=js&"
import style0 from "./WebTwoTrainReport.vue?vue&type=style&index=0&id=33e7a115&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e7a115",
  null
  
)

export default component.exports